import { useMemo, useCallback } from 'react'
import { message } from 'antd'
import { usePresignedUpload } from '../../../../hooks/usePresignedUpload'

const useVideoUpload = ({ videoId } = {}) => {
  const {
    isUploading,
    uploadProgress: presignedProgress,
    uploadFiles
  } = usePresignedUpload({ videoId })

  const progress = useMemo(() => {
    const values = Object.values(presignedProgress)
    return values.length > 0 ? values[values.length - 1] : 0
  }, [presignedProgress])

  const uploadVideo = useCallback(async file => {
    if (!file) return { success: false, url: null }

    try {
      const response = await uploadFiles({
        files: [file],
        category: 'video'
      })

      if (response.success && response.urls?.[0]) {
        return { success: true, url: response.urls[0] }
      }

      throw response.error || new Error('Upload failed')
    } catch (error) {
      message.error('Video upload failed')
      console.error('Video upload failed:', error)
      return { success: false, url: null, error }
    }
  }, [uploadFiles])

  return { isUploading, progress, uploadVideo }
}

export default useVideoUpload
